import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';

import { organizationServices } from '../../index';

export const useGetOrganizationUser = ({ userCode }, options = {}) =>
  useQuery(
    [QUERY_KEYS.useGetOrganizationUserKey, userCode],
    () => organizationServices.getOrganizationUser({ userCode }),
    {
      staleTime: 20 * 1000,
      ...options
    }
  );
